import React from "react";
import { Typography, Paper } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import TopOfAddStepTables from "../../CellStepManagement/components/TopOfAddStepTables";
import CachePage from "../../CellStepManagement/components/CachePage";
import CachePageModal from "../../CellStepManagement/components/CachePageModal";
import PaginationBlock from "./PaginationBlock";
import Divider from "@mui/material/Divider";

const StepTypeCachePage = ({
  openCacheModal,
  closeCacheModal,
  cachePageModalOpen,
  onCachePageSubmit,
  id,
  studyId,
  stepType,
  data,
  loading,
  rowsPerPage,
  currentPage,
  onPageChange,
  onRowsPerPageChange,
  onSearch,
  setHasSearched,
  hasSearched,
  resetStateToLoading,
  onSelectItem,
  handleClick,
  resultCount,
  onDone,
}) => {
  return (
    <div style={{ width: "100%" }}>
      <div style={{ padding: "4px 0 12px", width: "100%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 16,
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              minWidth: 220,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography variant="subtitle1" style={{ lineHeight: 1.2 }}>
              Add a new cache page step
            </Typography>

            <Typography
              variant="caption"
              color="textSecondary"
              style={{
                marginTop: 2,
                lineHeight: 1.2,
              }}
            >
              A cache page step is a webpage copied and hosted by Lumen, usually
              containing one or more ads.
            </Typography>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 8,
              marginLeft: "auto",
              minWidth: 0,
              flex: 1,
              justifyContent: "flex-end",
            }}
          >
            <div style={{ width: "100%", maxWidth: 420 }}>
              <TopOfAddStepTables
                button
                buttonText="Cache Page Step"
                buttonClick={openCacheModal}
                textFieldLabel="Search cache pages"
                textFieldChange={(term) => {
                  onSearch(term);
                  if (term.length > 2) {
                    setHasSearched(true);
                    resetStateToLoading();
                    onSelectItem(
                      stepType,
                      studyId,
                      term,
                      rowsPerPage,
                      currentPage
                    );
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <Paper
        elevation={0}
        square
        style={{
          padding: 0,
          borderRadius: 0,
          marginBottom: 24,
          background: "transparent",
        }}
      >
        {!cachePageModalOpen ? (
          <>
            <Divider
              sx={{
                borderColor: "rgba(0,0,0,0.08)",
              }}
            />

            {!hasSearched ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "64px 0",
                  color: "#888",
                  fontSize: "14px",
                }}
              >
                <SearchIcon style={{ fontSize: 50, marginBottom: 20 }} />
                <span>Search for a Cache Page</span>
              </div>
            ) : (
              <>
                <CachePage
                  onAddAll={(selectedIds) => {
                    selectedIds.forEach((cacheId) => {
                      handleClick(id, stepType, studyId, cacheId, { //here
                        closeAfter: false,
                      });
                    });
                    onDone?.();
                  }}
                  loading={loading}
                  cachePage={data}
                />

                <div
                  style={{
                    position: "sticky",
                    bottom: 0,
                    zIndex: 2,
                    background: "#fff",
                    padding: "8px 0",
                    borderTop: "1px solid rgba(0,0,0,0.08)",
                  }}
                >
                  <PaginationBlock
                    resultCount={resultCount}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                    onPageChange={onPageChange}
                    onRowsPerPageChange={onRowsPerPageChange}
                  />
                </div>
              </>
            )}
          </>
        ) : (
          <CachePageModal
            onCachePageSumbit={onCachePageSubmit}
            closeCacheModal={closeCacheModal}
          />
        )}
      </Paper>
    </div>
  );
};

export default StepTypeCachePage;